import { render, staticRenderFns } from "./BookMatchCustomerProfile.vue?vue&type=template&id=011b2e1e&scoped=true&"
import script from "./BookMatchCustomerProfile.vue?vue&type=script&lang=js&"
export * from "./BookMatchCustomerProfile.vue?vue&type=script&lang=js&"
import style0 from "./BookMatchCustomerProfile.vue?vue&type=style&index=0&id=011b2e1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011b2e1e",
  null
  
)

export default component.exports